import React from "react";

const formatDate = (dateString: string) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return dateString;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

export function InwardOutwardSummary({ application, startIndex }: { application: any; startIndex: number }) {
  const { inwardOutward } = application || {};
  const { inwardNo, inwardDate, outwardNo, outwardDate } = inwardOutward || {};

  if (!inwardNo && !inwardDate && !outwardNo && !outwardDate) return null;

  let i = startIndex + 1;

  return (
    <>
      {inwardNo && (
        <div className="flex items-center space-x-2 md:space-x-6 mb-2">
          <p className="text-grey-600 text-sm md:text-base font-semibold shrink-0 basis-1/3">{i++}. Inward No.</p>
          <p className="text-grey-600 text-sm md:text-base shrink-0">:</p>
          <p className="text-grey-600 text-sm md:text-base grow inline-block min-w-[100px] text-wrap break-words">{inwardNo}</p>
        </div>
      )}
      {inwardDate && (
        <div className="flex items-center space-x-2 md:space-x-6 mb-2">
          <p className="text-grey-600 text-sm md:text-base font-semibold shrink-0 basis-1/3">{i++}. Inward Date</p>
          <p className="text-grey-600 text-sm md:text-base shrink-0">:</p>
          <p className="text-grey-600 text-sm md:text-base grow inline-block min-w-[100px] text-wrap break-words">{formatDate(inwardDate)}</p>
        </div>
      )}
      {outwardNo && (
        <div className="flex items-center space-x-2 md:space-x-6 mb-2">
          <p className="text-grey-600 text-sm md:text-base font-semibold shrink-0 basis-1/3">{i++}. Outward No.</p>
          <p className="text-grey-600 text-sm md:text-base shrink-0">:</p>
          <p className="text-grey-600 text-sm md:text-base grow inline-block min-w-[100px] text-wrap break-words">{outwardNo}</p>
        </div>
      )}
      {outwardDate && (
        <div className="flex items-center space-x-2 md:space-x-6 mb-2">
          <p className="text-grey-600 text-sm md:text-base font-semibold shrink-0 basis-1/3">{i++}. Outward Date</p>
          <p className="text-grey-600 text-sm md:text-base shrink-0">:</p>
          <p className="text-grey-600 text-sm md:text-base grow inline-block min-w-[100px] text-wrap break-words">{formatDate(outwardDate)}</p>
        </div>
      )}
    </>
  );
}
